import { NgModule } from '@angular/core';

import { DealershipBadgeComponent } from './dealership.badge.component';
import { SharedModule }             from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    // Components
    DealershipBadgeComponent
  ],
  entryComponents: [
    DealershipBadgeComponent
  ],
  exports: [
    // Components
    DealershipBadgeComponent,
  ],
  imports: [
    SharedModule
  ]
})
export class DealershipModule {}